import { searchProductsCallOptions } from '../../services/products.services';
import { callApi } from '../api';
import {
  fetchFilterItemsCallOptions,
  FilterParams,
} from '../../services/filters.service';
import {
  FilterItem,
  getStreamCategoryConfigActiveFilterItems,
  getStreamCategoryConfigAppId,
  getStreamCategoryConfigCategory,
  getSelectedFilters,
} from './stream-category-config.reducer';
import { call, put, select, take, fork, all } from 'redux-saga/effects';
import {
  addStreamConfigActiveFilterItem,
  removeStreamConfigActiveFilterItem,
  selectStreamConfigCategory,
  setStreamConfigCategory,
  setStreamConfigLoading,
  updateStreamConfigActiveFilterItems,
  updateStreamConfigFilterNames,
  updateStreamConfigFilters,
  updateStreamConfigProductCount,
  toggleBlacklistForFilter,
  addStreamConfigActiveFilterItems,
  setUpdateFilterItemsComplete,
} from './stream-category-config.actions';
import {
  map,
  append,
  reject,
  mapObjIndexed,
  groupBy,
  sort,
  pickBy,
  merge,
} from 'ramda';

export function* watchForAddStreamConfigActiveFilterItem() {
  while (true) {
    const {
      payload: { filterItem },
    } = yield take(addStreamConfigActiveFilterItem.type);
    const state = yield select();
    const activeFilterItems = getStreamCategoryConfigActiveFilterItems(state);

    yield put(
      updateStreamConfigActiveFilterItems({
        filterItems: append(filterItem, activeFilterItems) as any,
      })
    );
    yield loadStreamConfigFilters();
  }
}

export function* watchForAddStreamActiveFilterItems() {
  while (true) {
    const {
      payload: { filterItems },
    } = yield take(addStreamConfigActiveFilterItems.type);
    const state = yield select();
    const activeFilterItems = getStreamCategoryConfigActiveFilterItems(state);

    const newFilterItems = [...filterItems, ...activeFilterItems];

    yield put(
      updateStreamConfigActiveFilterItems({
        filterItems: newFilterItems,
      })
    );
    yield loadStreamConfigFilters();
  }
}

export function* watchForRemoveStreamConfigActiveFilterItem() {
  while (true) {
    const {
      payload: { filterItem },
    } = yield take(removeStreamConfigActiveFilterItem.type);
    const state = yield select();
    const activeFilterItems = getStreamCategoryConfigActiveFilterItems(state);
    yield put(
      updateStreamConfigActiveFilterItems({
        filterItems: reject(
          activeFilterItem => (activeFilterItem as any).id === filterItem.id,
          activeFilterItems
        ),
      })
    );
    yield loadStreamConfigFilters();
  }
}

export function* watchForToggleBlacklistForFilter() {
  while (true) {
    yield take(toggleBlacklistForFilter.type);
    yield loadStreamConfigFilters();
  }
}

export function* watchForStreamConfigCategorySelect() {
  while (true) {
    const { payload } = yield take(selectStreamConfigCategory.type);
    yield put(setStreamConfigCategory(payload));
    yield loadStreamConfigFilters();
  }
}

const DEFAULT_FILTERS = [
  { attributeGroupId: 550, id: 'brand' },
  { attributeGroupId: 1, id: 'color' },
];

export const groupByFilterId = groupBy((filterItem: FilterItem) => {
  return filterItem.filterId;
});

export const mapIds = mapObjIndexed((filterItems: FilterItem[]) => {
  return map(filterItem => filterItem.id, filterItems);
});

const sortByCount = sort((filterItemA: FilterItem, filterItemB: FilterItem) => {
  const a = filterItemA.count || 0;
  const b = filterItemB.count || 0;
  return b - a;
});

function* loadStreamConfigFilters() {
  const state = yield select();
  const category = getStreamCategoryConfigCategory(state);
  const appId = getStreamCategoryConfigAppId(state);
  const activeFilterItems = getStreamCategoryConfigActiveFilterItems(state);

  const activeFilterIds = mapIds(groupByFilterId(activeFilterItems));
  let filterNames = {
    brand: 'Marke',
    color: 'Farbe',
  };

  if (!category || !appId) {
    return;
  }

  yield put(
    setStreamConfigLoading({
      loading: true,
    })
  );

  const selectedFilters = getSelectedFilters(state);
  const selectedFilterIds = mapIds(groupByFilterId(selectedFilters));

  yield fork(fetchProductCount, category.id, appId, selectedFilterIds);

  const promises = [];

  for (const defaultFilter of DEFAULT_FILTERS) {
    promises.push(call(
      fetchFilterItems,
      appId,
      category.id,
      defaultFilter.id,
      defaultFilter.attributeGroupId,
      pickBy(
        (val, activeFilterId) => defaultFilter.id !== activeFilterId,
        activeFilterIds
      )
    ) as never);
  }

  if (category.supportedFilters) {
    for (const additionalFilter of category.supportedFilters) {
      promises.push(call(
        fetchFilterItems,
        appId,
        category.id,
        additionalFilter.id,
        additionalFilter.uniqueId,
        pickBy(
          (val, activeFilterId) => additionalFilter.id !== activeFilterId,
          activeFilterIds
        )
      ) as never);
      filterNames = merge(filterNames, {
        [additionalFilter.id]: additionalFilter.name,
      });
    }

    yield put(updateStreamConfigFilterNames({ filterNames }));
  }

  yield all(promises);

  yield put(setUpdateFilterItemsComplete());
  yield put(setStreamConfigLoading({ loading: false }));
}

function* fetchProductCount(
  categoryId: number,
  appId: number,
  filters: FilterParams
) {
  const callOptions = searchProductsCallOptions(
    categoryId,
    appId,
    1,
    0,
    filters
  );
  const { ok, data } = yield call(callApi, callOptions);
  const productCount = ok ? data.totalCount : 0;
  yield put(updateStreamConfigProductCount({ productCount }));
}

function* fetchFilterItems(
  appId: number,
  categoryId: number,
  filterId: string,
  attributeGroupId: number,
  filters: FilterParams = {}
) {
  const options = fetchFilterItemsCallOptions(
    appId,
    filterId,
    categoryId,
    filters
  );
  const { ok, data } = yield call(callApi, options);

  if (ok) {
    const filterItems = map(filterItem => {
      return {
        ...filterItem,
        filterId,
        attributeGroupId,
      };
    }, data);
    yield put(
      updateStreamConfigFilters({
        availableFilters: { [filterId]: sortByCount(filterItems as any) },
      })
    );
  }

  return [];
}



// WEBPACK FOOTER //
// ./src/store/StreamCategoryConfig/stream-category-config.saga.ts